import { render } from "./Tab2vue.vue?vue&type=template&id=e872cee4"
import script from "./Tab2vue.vue?vue&type=script&lang=js"
export * from "./Tab2vue.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__